/* ============================================================
   LOYWIS THEME - Product Page JS
   File: assets/loywis-product.js
   ============================================================ */

(function () {
  'use strict';

  /* ── GALLERY ──────────────────────────────────────────────── */
  function initGallery() {
    var main    = document.getElementById('lw-gal-main-img');
    var thumbs  = document.querySelectorAll('.lw-gal-thumb');
    var mainWrap = document.querySelector('.lw-gal-main');
    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('lw-active'); });
        thumb.classList.add('lw-active');
        if (main) {
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          if (src) main.src = src;
          if (srcset) main.srcset = srcset;
          main.alt = thumb.getAttribute('data-alt') || '';
        }
      });

      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          thumb.click();
        }
      });
    });

    /* Zoom on click */
    if (mainWrap) {
      mainWrap.addEventListener('click', function () {
        if (main && main.src) {
          var zoom = window.open(main.src, '_blank', 'width=800,height=800');
          if (zoom) zoom.focus();
        }
      });
    }
  }

  /* ── WISHLIST ─────────────────────────────────────────────── */
  function initWishlist() {
    var btn = document.querySelector('.lw-gal-wish');
    if (!btn) return;
    var productId = btn.getAttribute('data-product-id') || '';
    var key = 'lw_wishlist';

    function getList() {
      try { return JSON.parse(localStorage.getItem(key)) || []; } catch(e) { return []; }
    }
    function saveList(list) {
      try { localStorage.setItem(key, JSON.stringify(list)); } catch(e) {}
    }

    var list = getList();
    if (productId && list.indexOf(productId) !== -1) {
      btn.classList.add('lw-active');
      btn.setAttribute('aria-pressed', 'true');
      btn.innerHTML = LWIcon('heart', 18);
    }

    btn.addEventListener('click', function () {
      list = getList();
      var idx = list.indexOf(productId);
      if (idx === -1) {
        list.push(productId);
        btn.classList.add('lw-active');
        btn.setAttribute('aria-pressed', 'true');
        btn.innerHTML = LWIcon('heart', 18);
      } else {
        list.splice(idx, 1);
        btn.classList.remove('lw-active');
        btn.setAttribute('aria-pressed', 'false');
        btn.innerHTML = LWIcon('heart-outline', 18);
      }
      saveList(list);
      /* Notify header to refresh badge */
      window.dispatchEvent(new CustomEvent('lw:wishlist-changed', { detail: { count: list.length } }));
    });
  }

  /* ── SHARE ────────────────────────────────────────────────── */
  function initShare() {
    var btn = document.querySelector('.lw-gal-util[data-action="share"]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({
          title: document.title,
          url: window.location.href
        }).catch(function () {});
      } else {
        try {
          navigator.clipboard.writeText(window.location.href).then(function () {
            btn.innerHTML = LWIcon('check', 14);
            setTimeout(function () { btn.innerHTML = LWIcon('share', 14); }, 2000);
          });
        } catch(e) {}
      }
    });
  }

  /* ── QUANTITY ─────────────────────────────────────────────── */
  function initQty() {
    var inp  = document.querySelector('.lw-qty-inp');
    /* HTML uses data-qty-action (not data-action) - fixed selectors */
    var decr = document.querySelector('.lw-qty-btn[data-qty-action="dec"]');
    var incr = document.querySelector('.lw-qty-btn[data-qty-action="inc"]');
    if (!inp) return;

    function clamp(v) { return Math.max(1, Math.min(99, v)); }

    if (decr) {
      decr.addEventListener('click', function (e) {
        e.preventDefault();
        inp.value = clamp((parseInt(inp.value) || 1) - 1);
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (incr) {
      incr.addEventListener('click', function (e) {
        e.preventDefault();
        inp.value = clamp((parseInt(inp.value) || 1) + 1);
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    inp.addEventListener('change', function () {
      var v = parseInt(inp.value);
      inp.value = isNaN(v) ? 1 : clamp(v);
    });
  }

  /* ── VARIANT CHIPS ────────────────────────────────────────── */
  function initVariantChips() {
    var form = document.querySelector('#lw-product-form') || document.querySelector('.lw-pd-form');
    if (!form) return;

    var groups = form.querySelectorAll('.lw-opt-group[data-option-index]');
    if (!groups.length) return;

    var product = null;
    var productJSON = document.getElementById('lw-product-json');
    if (productJSON) { try { product = JSON.parse(productJSON.textContent); } catch (e) {} }
    if (!product || !product.variants) return;

    /* Currently-selected value for each option group */
    function selectedValues() {
      var vals = [];
      groups.forEach(function (group) {
        var idx    = parseInt(group.getAttribute('data-option-index'), 10);
        var active = group.querySelector('.lw-opt-chip.lw-active');
        vals[idx]  = active ? active.getAttribute('data-opt-value') : null;
      });
      return vals;
    }

    /* Match the variant whose option values equal the selection */
    function findVariant(vals) {
      return product.variants.find(function (v) {
        var opts = v.options || [];
        for (var i = 0; i < vals.length; i++) {
          if (vals[i] != null && String(opts[i]) !== String(vals[i])) return false;
        }
        return true;
      });
    }

    function selectVariant() {
      var variant = findVariant(selectedValues());
      if (!variant) return;
      var idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.value = variant.id;
      updateVariantUI(variant);
      swapGalleryImage(variant);
    }

    /* Bind chip clicks */
    groups.forEach(function (group) {
      var chips   = group.querySelectorAll('.lw-opt-chip');
      var current = group.querySelector('[data-opt-current]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('lw-active'); c.setAttribute('aria-checked', 'false'); });
          chip.classList.add('lw-active');
          chip.setAttribute('aria-checked', 'true');
          if (current) current.textContent = chip.getAttribute('data-opt-value');
          selectVariant();
        });
      });
    });

    /* Price + availability - uses the store's own money format */
    function updateVariantUI(variant) {
      var available = variant.available;
      var pct = 0;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      }

      document.querySelectorAll('.lw-price-now, .lw-sc-price-now').forEach(function (el) {
        el.textContent = variant.price_formatted;
      });
      document.querySelectorAll('.lw-price-compare').forEach(function (el) {
        if (pct > 0 && variant.compare_at_formatted) { el.textContent = variant.compare_at_formatted; el.style.display = ''; }
        else { el.style.display = 'none'; }
      });
      document.querySelectorAll('.lw-price-deco').forEach(function (el) {
        if (pct > 0) { el.textContent = '-' + pct + '%'; el.style.display = ''; }
        else { el.style.display = 'none'; }
      });

      document.querySelectorAll('.lw-in-stock').forEach(function (el) {
        el.innerHTML = available ? LWIcon('check', 14) + ' In Stock · Ships Today' : LWIcon('x', 14) + ' Out of Stock';
        el.style.color = available ? '' : '#E05020';
      });

      var addBtn = document.querySelector('.lw-btn-cart');
      if (addBtn) { addBtn.disabled = !available; addBtn.innerHTML = available ? LWIcon('cart', 18) + ' Add to Cart' : LWIcon('x', 18) + ' Sold Out'; }
      var scCart = document.querySelector('.lw-sc-cart');
      if (scCart) { scCart.disabled = !available; }
      var buyBtn = document.querySelector('.lw-btn-buy');
      if (buyBtn) { buyBtn.disabled = !available; buyBtn.style.display = available ? '' : 'none'; }
    }

    /* Swap the main gallery image if the variant has one; otherwise leave it */
    function swapGalleryImage(variant) {
      if (!variant.featured_image) return;
      var mainImg = document.getElementById('lw-gal-main-img');
      var thumbs  = document.querySelectorAll('.lw-gal-thumb');
      var matched = null;
      thumbs.forEach(function (t) {
        if (t.getAttribute('data-src') === variant.featured_image) matched = t;
      });
      if (matched) {
        if (mainImg) {
          mainImg.src = matched.getAttribute('data-src');
          var ss = matched.getAttribute('data-srcset'); if (ss) mainImg.srcset = ss;
          var alt = matched.getAttribute('data-alt'); if (alt) mainImg.alt = alt;
        }
        thumbs.forEach(function (t) { t.classList.remove('lw-active'); t.setAttribute('aria-selected', 'false'); });
        matched.classList.add('lw-active');
        matched.setAttribute('aria-selected', 'true');
      } else if (mainImg) {
        mainImg.src = variant.featured_image;
        mainImg.removeAttribute('srcset');
      }
    }
  }

  /* ── FORMAT MONEY ─────────────────────────────────────────── */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '₹' + parseInt(amount).toLocaleString('en-IN');
  }

  /* ── ADD TO CART ──────────────────────────────────────────── */
  function initAddToCart() {
    var form   = document.querySelector('.lw-pd-form');
    var addBtn = document.querySelector('.lw-btn-cart');
    if (!form || !addBtn) return;

    var originalHTML = (addBtn.innerHTML && addBtn.innerHTML.trim()) ? addBtn.innerHTML : (LWIcon('cart', 18) + ' Add to Cart');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var formData = new FormData(form);
      var qtyInput = document.querySelector('.lw-qty-inp');
      if (qtyInput) formData.set('quantity', parseInt(qtyInput.value, 10) || 1);

      addBtn.disabled = true;
      addBtn.innerHTML = LWIcon('hourglass', 18) + ' Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (item) {
        addBtn.innerHTML = LWIcon('check', 18) + ' Added to Cart';
        addBtn.style.background = 'var(--lw-green, #1B7F4F)';

        showAddedToCartToast(item);
        updateCartCount();

        setTimeout(function () {
          addBtn.disabled = false;
          addBtn.innerHTML = originalHTML;
          addBtn.style.background = '';
        }, 2400);
      })
      .catch(function (err) {
        addBtn.disabled = false;
        addBtn.innerHTML = originalHTML;
        showAddedToCartToast(null, err && err.description ? err.description : 'Could not add to cart. Please try again.');
      });
    });

    /* Sticky CTA cart button */
    var scCart = document.querySelector('.lw-sc-cart');
    if (scCart) {
      scCart.addEventListener('click', function (e) {
        e.preventDefault();
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* ── ADDED-TO-CART TOAST NOTIFICATION ─────────────────────── */
  function showAddedToCartToast(item, errorMsg) {
    var existing = document.querySelector('.lw-atc-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'lw-atc-toast' + (errorMsg ? ' lw-atc-toast--err' : '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    if (errorMsg) {
      toast.innerHTML =
        '<div class="lw-atc-toast__icon">' + LWIcon('alert', 18) + '</div>' +
        '<div class="lw-atc-toast__body">' +
          '<div class="lw-atc-toast__title">Couldn\'t add to cart</div>' +
          '<div class="lw-atc-toast__msg"></div>' +
        '</div>' +
        '<button class="lw-atc-toast__close" aria-label="Close">' + LWIcon('close', 14) + '</button>';
      toast.querySelector('.lw-atc-toast__msg').textContent = errorMsg;
    } else {
      var img = item && item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2') : '';
      var title = item && (item.product_title || item.title) ? (item.product_title || item.title) : 'Item';
      var variant = item && item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var qty = item && item.quantity ? item.quantity : 1;
      var price = item && typeof item.final_line_price === 'number' ? formatMoney(item.final_line_price) : '';

      toast.innerHTML =
        '<div class="lw-atc-toast__icon">' + LWIcon('check', 18) + '</div>' +
        (img ? '<img class="lw-atc-toast__img" src="' + img + '" alt="">' : '') +
        '<div class="lw-atc-toast__body">' +
          '<div class="lw-atc-toast__title">Added to cart</div>' +
          '<div class="lw-atc-toast__name"></div>' +
          (variant ? '<div class="lw-atc-toast__variant"></div>' : '') +
          '<div class="lw-atc-toast__meta">' +
            '<span class="lw-atc-toast__qty">Qty: ' + qty + '</span>' +
            (price ? '<span class="lw-atc-toast__price">' + price + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<div class="lw-atc-toast__actions">' +
          '<a class="lw-atc-toast__view" href="/cart">View Cart</a>' +
          '<button class="lw-atc-toast__close" aria-label="Close">' + LWIcon('close', 14) + '</button>' +
        '</div>';

      toast.querySelector('.lw-atc-toast__name').textContent = title;
      if (variant) toast.querySelector('.lw-atc-toast__variant').textContent = variant;
    }

    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('lw-show'); });

    var closeBtn = toast.querySelector('.lw-atc-toast__close');
    function dismiss() {
      toast.classList.remove('lw-show');
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 320);
    }
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    setTimeout(dismiss, errorMsg ? 5000 : 4500);
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var badges = document.querySelectorAll('.lw-hdr__cart-count, [data-lw-cart-count], .cart-count-bubble, .cart-badge, [data-cart-count]');
      badges.forEach(function (el) {
        if (cart.item_count > 0) {
          el.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
          el.hidden = false;
          el.style.display = '';
        } else {
          el.hidden = true;
        }
      });
      /* Dispatch event so header script can sync too */
      window.dispatchEvent(new CustomEvent('lw:cart-changed', { detail: cart }));
    })
    .catch(function () {});
  }

  /* ── BUY NOW ──────────────────────────────────────────────── */
  function initBuyNow() {
    var btn  = document.querySelector('.lw-btn-buy');
    var form = document.getElementById('lw-product-form');
    if (!btn || !form) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = form.querySelector('[name="id"]').value;
      var qty       = parseInt(document.querySelector('.lw-qty-inp') ? document.querySelector('.lw-qty-inp').value : 1) || 1;
      var original  = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = LWIcon('hourglass', 18) + ' Processing…';
      /* Add the item to the cart first, then go to checkout */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () {
          btn.disabled = false;
          btn.innerHTML = original;
          window.location.href = '/cart';
        });
    });
  }

  /* ── WHATSAPP ORDER ───────────────────────────────────────── */
  function initWAButtons() {
    var waNum  = document.querySelector('[data-wa-number]');
    if (!waNum) return;
    var number = waNum.getAttribute('data-wa-number') || '';
    if (!number) return;

    document.querySelectorAll('[data-action="wa-order"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var customMsg = btn.getAttribute('data-wa-message') || '';
        var productTitle = document.querySelector('.lw-prod-title') ? document.querySelector('.lw-prod-title').textContent.trim() : document.title;
        var url          = window.location.href;
        var selectedOpts = [];
        document.querySelectorAll('.lw-opt-chip.lw-active').forEach(function (c) {
          selectedOpts.push(c.getAttribute('data-opt-value'));
        });
        var optStr = selectedOpts.length ? ' (' + selectedOpts.join(', ') + ')' : '';
        var msg    = customMsg || ('Hi! I want to order: ' + productTitle + optStr + '\n' + url);
        window.open('https://wa.me/' + number.replace(/\D/g, '') + '?text=' + encodeURIComponent(msg), '_blank');
      });
    });
  }

  /* ── COUPON COPY ──────────────────────────────────────────── */
  function initCouponCopy() {
    var code = document.querySelector('.lw-b2g1-code');
    var msg  = document.querySelector('.lw-b2g1-copied');
    if (!code) return;

    code.addEventListener('click', function () {
      var text = code.textContent.trim();
      try {
        navigator.clipboard.writeText(text).then(function () {
          if (msg) { msg.style.display = 'inline'; setTimeout(function () { msg.style.display = 'none'; }, 2000); }
        });
      } catch(e) {
        if (msg) { msg.style.display = 'inline'; setTimeout(function () { msg.style.display = 'none'; }, 2000); }
      }
    });
  }

  /* ── COUNTDOWN TIMER ──────────────────────────────────────── */
  function initTimer() {
    var timer = document.querySelector('.lw-sale-timer');
    if (!timer) return;
    var hEl = timer.querySelector('[data-timer-part="h"]');
    var mEl = timer.querySelector('[data-timer-part="m"]');
    var sEl = timer.querySelector('[data-timer-part="s"]');
    if (!hEl || !mEl || !sEl) return;

    var storageKey = 'lw_timer_end';
    var durationMs = (parseInt(timer.getAttribute('data-timer-hours') || 3, 10) * 3600 +
                      parseInt(timer.getAttribute('data-timer-mins')  || 47, 10) * 60) * 1000;

    var end = parseInt(localStorage.getItem(storageKey));
    if (!end || end < Date.now()) {
      end = Date.now() + durationMs;
      try { localStorage.setItem(storageKey, end); } catch(e) {}
    }

    function tick() {
      var diff = Math.max(0, end - Date.now());
      var h    = Math.floor(diff / 3600000);
      var m    = Math.floor((diff % 3600000) / 60000);
      var s    = Math.floor((diff % 60000) / 1000);
      hEl.textContent = String(h).padStart(2, '0');
      mEl.textContent = String(m).padStart(2, '0');
      sEl.textContent = String(s).padStart(2, '0');
      if (diff > 0) requestAnimationFrame(function () { setTimeout(tick, 1000); });
    }
    tick();
  }

  /* ── PINCODE CHECKER ──────────────────────────────────────── */
  function initPincode() {
    var inp = document.querySelector('.lw-pin-input');
    var btn = document.querySelector('.lw-pin-btn');
    var res = document.querySelector('.lw-pin-result');
    if (!inp || !btn || !res) return;

    function check() {
      var pin = inp.value.trim();
      if (!/^\d{6}$/.test(pin)) {
        res.innerHTML = LWIcon('alert', 14) + ' Enter a valid 6-digit pincode';
        res.className   = 'lw-pin-result lw-err';
        return;
      }
      res.innerHTML = LWIcon('hourglass', 14) + ' Checking…';
      res.className   = 'lw-pin-result lw-ok';
      /* Simulate check - replace with real API call if available */
      setTimeout(function () {
        res.innerHTML = LWIcon('check', 14) + ' Delivery available · 3–5 business days';
        res.className   = 'lw-pin-result lw-ok';
      }, 700);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      check();
    });
    /* Prevent Enter from submitting the parent product form (which would Add to Cart) */
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        check();
      }
    });
    /* Older browsers / iOS - also intercept keypress */
    inp.addEventListener('keypress', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
    inp.addEventListener('input', function () {
      inp.value = inp.value.replace(/\D/g, '').slice(0, 6);
    });
  }

  /* ── STICKY CTA ───────────────────────────────────────────── */
  function initStickyCTA() {
    var bar     = document.querySelector('.lw-sticky-cta');
    var ctaRef  = document.querySelector('.lw-cta-stack');
    if (!bar || !ctaRef) return;

    var shown = false;
    function onScroll() {
      var rect = ctaRef.getBoundingClientRect();
      if (!shown && rect.bottom < 0) {
        bar.classList.add('lw-show');
        shown = true;
      } else if (shown && rect.bottom > 100) {
        bar.classList.remove('lw-show');
        shown = false;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── PURCHASE TOAST ───────────────────────────────────────── */
  function initToast() {
    var toast = document.querySelector('.lw-purchase-toast');
    if (!toast) return;

    var names    = ['Priya S.', 'Ananya P.', 'Ritu M.', 'Kavya R.', 'Deepa K.', 'Sonal T.'];
    var cities   = ['Mumbai', 'Delhi', 'Jaipur', 'Pune', 'Ahmedabad', 'Chennai'];
    var messages = ['just ordered this', 'added to cart', 'placed an order', 'bought this today'];
    var times    = ['2 mins ago', '5 mins ago', '8 mins ago', '12 mins ago'];

    /* Build the inner structure once (the Liquid renders an empty container) */
    if (!toast.querySelector('.lw-toast-name')) {
      toast.innerHTML =
        '<span class="lw-toast-av" aria-hidden="true"></span>' +
        '<div class="lw-toast-text">' +
          '<div class="lw-toast-name"></div>' +
          '<div class="lw-toast-msg"></div>' +
          '<div class="lw-toast-time"></div>' +
        '</div>';
    }

    function showToast() {
      var nameEl = toast.querySelector('.lw-toast-name');
      var msgEl  = toast.querySelector('.lw-toast-msg');
      var timeEl = toast.querySelector('.lw-toast-time');
      var avEl   = toast.querySelector('.lw-toast-av');
      if (!nameEl) return;

      var r = function (arr) { return arr[Math.floor(Math.random() * arr.length)]; };
      var who = r(names);
      nameEl.textContent = who + ', ' + r(cities);
      msgEl.textContent  = r(messages);
      timeEl.textContent = r(times);
      if (avEl) avEl.textContent = LWIcon.monogram(who);

      toast.classList.add('lw-show');
      setTimeout(function () { toast.classList.remove('lw-show'); }, 4000);
    }

    /* First show after 5s, repeat every 18s */
    setTimeout(function () {
      showToast();
      setInterval(showToast, 18000);
    }, 5000);
  }

  /* ── VIEWER COUNT RANDOMIZER ──────────────────────────────── */
  function initViewerCount() {
    var el = document.querySelector('[data-viewer-count]');
    if (!el) return;
    var m    = el.textContent.match(/\d+/);
    var base = m ? parseInt(m[0], 10) : 20;

    function randomize() {
      var delta = Math.floor(Math.random() * 5) - 2;
      base = Math.max(10, base + delta);
      el.textContent = el.textContent.replace(/\d+/, base);   // keep surrounding text e.g. "viewing now"
    }
    setInterval(randomize, 7000);
  }

  /* ── INIT ALL ─────────────────────────────────────────────── */
  function init() {
    initGallery();
    initWishlist();
    initShare();
    initQty();
    initVariantChips();
    initAddToCart();
    initBuyNow();
    initWAButtons();
    initCouponCopy();
    initTimer();
    initPincode();
    initStickyCTA();
    initToast();
    initViewerCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
